export default {
  name: 'job',
  components: {},
  props: [],
  data() {
    return {}
  },
  computed: {
    job() {
      var res = {} 
      this.$store.state.jobs.forEach(job => {
        if(job.id == this.$route.params.jobId){
          res = job
        }
      });
      return res
    },
    contact() {
      var res = {} 
      this.$store.state.people.forEach(p => {
        if(p.id == "christoph-nissen"){
          res = p
        }
      });
      return res
    }
  },
  mounted() {
  },
  methods: {
  }
}